import { render, staticRenderFns } from "./MiroModalWrapper.vue?vue&type=template&id=079b9698&scoped=true&"
import script from "./MiroModalWrapper.vue?vue&type=script&lang=js&"
export * from "./MiroModalWrapper.vue?vue&type=script&lang=js&"
import style0 from "./MiroModalWrapper.vue?vue&type=style&index=0&id=079b9698&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079b9698",
  null
  
)

export default component.exports